/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";

import Stack from "@mui/material/Stack";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import Div from "@jumbo/shared/Div";
import { useDispatch, useSelector } from "react-redux";
import Loader from "@jumbo/components/Loader";
import { userType } from "app/helpers/userType";
import {
  PRODUCT_ADD,
  productEdit,
  officeProductVariant,
} from "app/routes/constant";
import { useNavigate } from "react-router-dom";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import {
  deleteProduct,
  getProductList,
  updateProductStatus,
} from "app/redux/slice/productSlice";
import { useSnackbar } from "notistack";

const Product = () => {
  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();
  const { isMA } = userType();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const productData = useSelector((state) => state?.product);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [isInitialized, setIsInitialized] = useState(false);

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "uniqueVariant" });

  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission")),
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    deletePermission: false,
    listVariantPermission: false,
  });

  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        deletePermission: true,
        listVariantPermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        deletePermission: false,
        listVariantPermission: false,
      };

      permissionData?.length &&
        permissionData.forEach(function (num) {
          if (num?.name === "create-product") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "delete-product") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "update-product") {
            permissionValue.updatePermission = true;
          }
          if (num?.name === "list-variant") {
            permissionValue.listVariantPermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const columns = [
    { id: "name", label: "Name", sort: true },
    { id: "productCode", label: "Code", sort: true },
    {
      id: "fabricId",
      label: "Fabric",
      render: (row) => <>{row?.fabricId?.name}</>,
    },
    {
      id: "categoryId",
      label: "Category",
      render: (row) => <>{row?.categoryId?.name}</>,
    },
    {
      id: "tags",
      label: "Tags",
      render: (row) => row?.tags?.join(", "),
    },
    { id: "productQuantity", label: "Qty", sort: true },
    { id: "sampleQty", label: "Sample  Qty" },
    { id: "producibleQty", label: "Producible Qty", sort: true },
    {
      id: "is_active",
      label: "Status",
      render: (row) => (
        <Switch
          checked={Boolean(row?.is_active)}
          color="success"
          size="medium"
          onChange={() => handleChangeStatus(row)}
        />
      ),
    },
    {
      id: "actions",
      label: "Actions",
      align: "center",
      minWidth: 170,
      render: (row) => (
        <>
          <IconButton
            disabled={!permission.updatePermission}
            onClick={() => {
              stageAction(row);
              navigate(productEdit(row._id));
            }}
          >
            <EditIcon />
          </IconButton>
          <Tooltip title="Variants List">
            <IconButton
              disabled={!permission.listVariantPermission || !row?.hasVariant}
              onClick={() => {
                stageAction(row);
                navigate(officeProductVariant(row._id));
              }}
            >
              <FormatListBulletedIcon />
            </IconButton>
          </Tooltip>
          <IconButton
            disabled={!permission.deletePermission}
            onClick={() => {
              deleteStageAction(row);
            }}
          >
            <DeleteIcon color={"error"} />
          </IconButton>
        </>
      ),
    },
  ];

  const DeleteProduct = () => {
    closeDelete();
    dispatch(deleteProduct(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };
  const handleChangeStatus = (rowData) => {
    dispatch(updateProductStatus(rowData?._id))
      .unwrap()
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          enqueueSnackbar(res?.data?.responseMessage, {
            variant: "success",
          });
          getData();
        } else {
          enqueueSnackbar(res?.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    localStorage.setItem("product-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getProductList(value));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    getPermission();

    const savedSearchText = localStorage.getItem("product-search") || "";
    setSearchText(savedSearchText);
    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (isInitialized) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, dispatch, order, orderBy, isInitialized]);

  useEffect(() => {
    if (isInitialized && searchText !== "") {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized]);

  return (
    <>
      {productData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 1, md: 3 }}>
                  <Grid item xs={12} sm={10}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Product List
                </Typography>
                {permission.createPermission && (
                  <LoadingButton
                    onClick={() => {
                      navigate(PRODUCT_ADD);
                    }}
                    type="submit"
                    variant="contained"
                    sx={{
                      mt: { xs: 1, md: 0 },
                    }}
                  >
                    Add Product
                  </LoadingButton>
                )}
              </Stack>
              <Table
                columns={columns}
                rows={productData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={productData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the product?"
            onConfirm={DeleteProduct}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
        </>
      )}
    </>
  );
};

export default Product;
